module.exports = __webpack_public_path__ + "static/media/relatorios.03bc04db.png";